import { FlowRoute, FlowRouteCategory } from '@eneco/flows/types';

import { FlowConsumerContextEnergy } from '../../context';
import { ContactDetailsStep, PersonalDetailsStep } from '../steps';

export const detailsTailRoutes: FlowRoute<FlowConsumerContextEnergy>[] = [
  {
    id: 'PERSONAL_DETAILS',
    path: '/je-gegevens/persoonlijke-gegevens/',
    category: FlowRouteCategory.Details,
    component: PersonalDetailsStep,
  },

  {
    id: 'CONTACT_DETAILS',
    path: '/je-gegevens/contactgegevens/',
    category: FlowRouteCategory.Details,
    component: ContactDetailsStep,
  },
];
